// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_2yU3_Wf8dLZOP46BoUT-t-"};